import React from 'react';

function Button({ children, className = '', ...props }) {
	return (
		<button className={`btn-primary ${className}`} {...props}>
			{children}
		</button>
	);
}

export default Button;


